import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { ControllerWrapper } from '../../../../hooks/providers/ControllerWrapper';
import { ExtendedUseFormReturn } from '../../../../hooks/providers/useFormHooks';
import { LiliTextInput } from '../../../../DesignSystem/LiliTextInput/LiliTextInput';
import Heading from '../../../../generic-components/Heading';
import { STATES_ARRAY } from '../../../../flows/liliCard/constants';
import { ReactComponent as DownArrowIcon } from '../../../../assets/icons/svg/shared/ic-shared-down-arrow.svg';
import { UpdateVendorFormFieldsMap, UpdateVendorFormProps } from '../../interfaces';

interface AddressFieldsProps {
  formMethods: ExtendedUseFormReturn<UpdateVendorFormProps>
}

export const DomesticAddressFields = (props: AddressFieldsProps) => {
  const { formMethods: { control } } = props;

  return (
    <>
      <ControllerWrapper name={UpdateVendorFormFieldsMap.LINE_1} control={control}>
        { ({ onBlur, onChange, error, value }) => <LiliTextInput
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          id={UpdateVendorFormFieldsMap.LINE_1}
          title='Address (no P.O box)'
          errorMessage={error?.message}
        /> }
      </ControllerWrapper>

      <div className='flex items-center w-full gap-[24px]'>

        <div className='w-full'>
          <ControllerWrapper name={UpdateVendorFormFieldsMap.LINE_2} control={control}>
            { ({ onBlur, onChange, error, value }) => <LiliTextInput
              onChange={onChange}
              value={value}
              onBlur={onBlur}
              id={UpdateVendorFormFieldsMap.LINE_2}
              title='Apt/Suite (optional)'
              errorMessage={error?.message}
            /> }
          </ControllerWrapper>
        </div>

        <div className='w-full'>
          <ControllerWrapper name={UpdateVendorFormFieldsMap.CITY} control={control}>
            { ({ onBlur, onChange, error, value }) => <LiliTextInput
              onChange={onChange}
              value={value}
              onBlur={onBlur}
              id={UpdateVendorFormFieldsMap.CITY}
              title='City'
              errorMessage={error?.message}
            /> }
          </ControllerWrapper>
        </div>
      </div>

      <ControllerWrapper name={UpdateVendorFormFieldsMap.POSTAL_CODE} control={control}>
        {({ onBlur, onChange, error, value }) => <LiliTextInput
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          id={UpdateVendorFormFieldsMap.POSTAL_CODE}
          title='Postal Code'
          errorMessage={error?.message}
          maxLength={5}
        />}
      </ControllerWrapper>

      <ControllerWrapper name={UpdateVendorFormFieldsMap.STATE} control={control}>
        {({ onChange, value, onBlur }) =>
          <div className='min-h-[76px] w-full'>
            <Dropdown
              value={value}
              onBlur={onBlur}
              onChange={(e) => onChange(e.value)}
              options={STATES_ARRAY}
              optionLabel='STATE'
              optionValue='POSTAL'
              itemTemplate={(item) => <Heading title={item.STATE} className='font-metricR text-bw08' />}
              placeholder='State'
              className='vendorCustomDropDown'
              panelClassName='vendorDropDown rounded-[8px] shadow-2xl'
              dropdownIcon={<DownArrowIcon className='text-action03' />}
            />
          </div>}
      </ControllerWrapper>

    </>
  );
};
